import { combineActions, handleActions } from 'redux-actions';
import {
  publishTier,
  updateTier,
  tierSaveError,
  tierSaveRedirect,
  tierSaveRedirectAfterDraft,
} from './actions';
import { TierPopupStoreSlice } from './types';

const reducers = handleActions<TierPopupStoreSlice, any>(
  {
    [combineActions(publishTier, updateTier).toString()]: (
      state,
      action
    ): TierPopupStoreSlice => ({
      ...state,
      requestStatus: 'fetching',
      errorMessage: undefined,
    }),
    [tierSaveError.toString()]: (
      state,
      action: ReturnType<typeof tierSaveError>
    ) => ({
      ...state,
      requestStatus: 'error',
      errorMessage: action.payload.message,
    }),
    [tierSaveRedirect.toString()]: (
      state,
      action: ReturnType<typeof tierSaveRedirect>
    ) => ({
      ...state,
      requestStatus: 'redirecting',
    }),
    [tierSaveRedirectAfterDraft.toString()]: (
      state,
      action: ReturnType<typeof tierSaveRedirectAfterDraft>
    ) => ({
      ...state,
      requestStatus: 'redirecting_after_draft',
    }),
  },
  {
    requestStatus: 'idle',
  }
);
export default reducers;
